<template>
    <v-system-bar 
      app 
      color="red darken-1" 
      dark 
      height="40" 
      v-if="showWarning"
      data-bar="subscription"
    >
      <v-icon>mdi-alert-circle</v-icon>
      <span class="ml-2">Esta cuenta no tiene una suscripción activa.</span>
      <span v-if="dealerName" class="ml-1">Concesionario: <strong>{{ dealerName }}</strong></span>
      <v-spacer></v-spacer>
    </v-system-bar>
  </template>
  
  <script>
  import { mapGetters } from 'vuex'
// import DealerService from '../../services/DealerService'
import UserService from '../../services/UserService'
  
  export default {
    data() {
      return {
        loading: false,
        dealerName: '',
        noSubscription: false
      }
    },
    
    computed: {
      ...mapGetters(['IN_SWITCHED_SESSION', 'CURRENT_USER', 'HAS_ROLE']),
      
      // Mostrar advertencia solo si:
      // 1. Estamos en sesión cambiada
      // 2. El usuario no tiene suscripción activa
      // 3. El usuario actual es admin (tiene permisos para ver/gestionar)
      showWarning() {
        const inSwitchedSession = this.IN_SWITCHED_SESSION
        const hasNoSubscription = this.noSubscription
        const isAdmin = this.HAS_ROLE(['admin'])
        // console.log('IN_SWITCHED_SESSION:', inSwitchedSession)
        // console.log('noSubscription:', hasNoSubscription)
        // console.log('isAdmin:', isAdmin)
        
        return inSwitchedSession && hasNoSubscription && !isAdmin
      }
    },
    
    methods: {
      goToSubscriptionPage() {
        this.loading = true
        try {
          // Redirigir a la página de gestión de suscripciones
          this.$router.push({ name: 'Subscription' })
        } catch (error) {
          console.error('Error al navegar a la página de suscripciones:', error)
        } finally {
          this.loading = false
        }
      },
      
      async checkSubscriptionStatus() {
        try {
          // Obtener información del usuario actual/concesionario actual
          const response = await UserService.getMe()
          
          if (response.data && response.data.data) {
            const dealer = response.data.data.dealer
            this.dealerName = dealer.name || ''
            
            // Verificar si tiene suscripción activa o balance
            const balance = dealer && dealer.balance ? dealer.balance : null
            const status = balance && balance.subscription_status
              ? String(balance.subscription_status).toLowerCase()
              : null

            const activeStatuses = ['active', 'trialing']

            this.noSubscription = !balance || !activeStatuses.includes(status)
          }
        } catch (error) {
          console.error('Error al verificar estado de suscripción:', error)
        }
      }
    },
    
    watch: {
      // Verificar estado de suscripción cuando cambiamos de usuario
      CURRENT_USER: {
        handler() {
          if (this.IN_SWITCHED_SESSION) {
            this.checkSubscriptionStatus()
          } else {
            this.noSubscription = false
          }
        },
        deep: true
      },
      
      // También verificar cuando cambia el estado de sesión cambiada
      IN_SWITCHED_SESSION(newValue) {
        if (newValue) {
          this.checkSubscriptionStatus()
        } else {
          this.noSubscription = false
        }
      }
    },
    
    created() {
      // Verificar estado inicial
      if (this.IN_SWITCHED_SESSION) {
        this.checkSubscriptionStatus()
      }
    }
  }
  </script>
  
  <style scoped>
  .v-system-bar {
    font-weight: 500;
  }
  
  /* Animación de parpadeo para llamar la atención */
  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.85;
    }
    100% {
      opacity: 1;
    }
  }
  
  .v-system-bar.red {
    animation: pulse 2s infinite;
  }
  </style>
